module.exports = __webpack_public_path__ + "static/media/logo.e314d696.png";